import { FormCheck } from "react-bootstrap";
import styled from "@emotion/styled";

const CustomFormCheck = styled(FormCheck)`
    .custom-control-label:before {
        background-color: #dddddd;
        border: 1px solid #dddddd;
    }
`;

export default CustomFormCheck;
